<template>
  <div>
    <p>
      Här får du med ett stolpskydd till varje gavel. Stolpskydden skyddar stolpen vid påkörning.
    </p>
  </div>
</template>
<script>

import UprightProtectorsInfo from "@/components/infotext/UprightProtectorsInfo.vue";

export default {
  components: {
    UprightProtectorsInfo
  }
}
</script>